import { PLAN_IDS } from '../constants/subscriptionPlans';

export const TOUR_PARTY_COVERAGE_FIELD = 'tourPartyCoverages';

export function normalizeTourPartyCoverages(user) {
  const raw = user?.[TOUR_PARTY_COVERAGE_FIELD];
  if (!Array.isArray(raw)) return [];
  return raw
    .map((row) => ({
      sponsorUid: String(row?.sponsorUid || '').trim(),
      tourId: String(row?.tourId || '').trim(),
      periodEnd: row?.periodEnd || null,
      planId: row?.planId || PLAN_IDS.VRC_MEMBER,
      tourName: row?.tourName || null,
    }))
    .filter((row) => row.sponsorUid && row.tourId && row.periodEnd);
}

export function getActiveTourPartyCoverages(user, now = new Date()) {
  const t = now.getTime();
  return normalizeTourPartyCoverages(user).filter((row) => {
    const end = new Date(row.periodEnd).getTime();
    return Number.isFinite(end) && end > t;
  });
}

/** Crew on a covered tour — Map + Calendar without their own Stripe subscription. */
export function hasTourPartyCrewAccess(user) {
  return getActiveTourPartyCoverages(user).length > 0;
}

export function getPrimaryTourPartyCoverage(user) {
  const active = getActiveTourPartyCoverages(user);
  if (!active.length) return null;
  active.sort((a, b) => new Date(b.periodEnd).getTime() - new Date(a.periodEnd).getTime());
  return active[0];
}
